import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import backArrow from 'images/CheckoutJourney/backArrow.svg';
import { sendAnalyticsData } from 'containers/ProductTour/helper';
import { NavigationWrapper } from 'containers/CheckoutJourney/styled';
import { VISIBILITY_CONFIG } from 'containers/CheckoutJourney/util/constant';
import { normalizePath } from 'containers/CheckoutJourney/util/helper';
import { StepNavigationProps } from 'containers/CheckoutJourney/types';

import ExitSetupModal from 'containers/CheckoutJourney/components/ExitModal';

import { Space, Text, Theme } from '@cashfree-intl/coherent';

const StepNavigation = ({
  previousLabel = 'Previous',
  deferLabel = 'I will do this later',
}: StepNavigationProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setIsOpen] = useState(false);

  const normalizedPath = normalizePath(location.pathname);

  const { showPrevious = true, showDefer = true } =
    VISIBILITY_CONFIG[normalizedPath] || {};

  const handlePreviousClick = () => {
    navigate(-1);
    sendAnalyticsData('previousScreenButtonClicked');
  };

  const onDeferButtonClick = () => {
    if (deferLabel === 'I will do this later') {
      setIsOpen(true);
    }
    sendAnalyticsData('iWillDoThisLaterClicked');
  };

  const onClose = () => {
    setIsOpen(false);
    sendAnalyticsData('continueSetupButtonClicked');
  };

  return (
    <Theme font="sans">
      <NavigationWrapper
        justifyContent={!showPrevious ? 'end' : 'space-between'}
        alignItems="center"
        fullWidth
      >
        {showPrevious && (
          <Space
            gap={0.5}
            alignItems="center"
            onClick={handlePreviousClick}
            style={{ cursor: 'pointer' }}
          >
            <img src={backArrow} alt="Back" />
            <Text as="span" variant="b14" strong style={{ cursor: 'pointer' }}>
              {previousLabel}
            </Text>
          </Space>
        )}

        {showDefer && (
          <Text
            variant="b14"
            as="span"
            strong
            onClick={onDeferButtonClick}
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
          >
            {deferLabel}
          </Text>
        )}
      </NavigationWrapper>

      <ExitSetupModal open={open} onClose={onClose} />
    </Theme>
  );
};

export default StepNavigation;
